import { Rule } from "antd/es/form";
import { TFunction } from "i18next";

/* export interface ValidationRule {
    rule: 'required' | 'noSpace' | 'minLength' | 'maxLength' | 'pattern';
    value: any;
    messageKey: string
} */

export interface ValidationConfig {
    value: any;
    flags?: any;
    messageKey: string;
}

export interface ValidationsObject { 
    required?: ValidationConfig;
    noOnlySpaces?: ValidationConfig;
    minLengthTrimmed?: ValidationConfig;
    maxLengthTrimmed?: ValidationConfig;
    pattern?: ValidationConfig;
}

export const mapValidationsFromJsonToFormRules = ( validations: ValidationsObject | undefined, t: TFunction): Rule[] => {
    if(!validations) return [];

    return Object.entries(validations)?.map(([ruleName, config]) => {
        const {value, flags, messageKey} = config as ValidationConfig;

        switch (ruleName){
            case 'required': 
                return {required : value, message: t(messageKey)};
                
            case 'noOnlySpaces':
                return {
                    validator: (_: any, val: string) => {
                        if(value && val && val.trim() === ''){
                            return Promise.reject(t(messageKey));
                        }
                        return Promise.resolve();
                    }
                }

            case 'minLengthTrimmed':
                return {
                      validator: (_, value) => {
                        if (!value || value.trim() === '') {    
                          return Promise.resolve();
                        }

                        const trimmedLength = value.replace(/\s/g, '').length;
                        if (trimmedLength < 5) {
                          return Promise.reject(t(messageKey));
                        }
                        return Promise.resolve();
                      },
                    }
                    
                // return {min : value, message: t(messageKey)};

            case 'maxLengthTrimmed':
                return {
                      validator: (_, value) => {
                        if (!value || value.trim() === '') {
                          return Promise.resolve();
                        }

                        const trimmedLength = value.replace(/\s/g, '').length;
                        if (trimmedLength > 100) {
                          return Promise.reject(t(messageKey));
                        }
                        return Promise.resolve();
                      },
                    }
                // return {max : value, message: t(messageKey)};

            case 'pattern':
                return {pattern : new RegExp(value, flags), message: t(messageKey)};           
            
            default: 
                return {}
        }
    })
}